import React from 'react'
import { Button } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

interface DesignAndPriceButtonProps {
  onClick(): void
}

const DesignAndPriceButton: React.FC<DesignAndPriceButtonProps> = ({
  onClick,
}) => {
  return (
    <Button
      id="milliplex-design-and-price-button"
      variant="outlined"
      color="primary"
      size="medium"
      onClick={onClick}
    >
      <FormattedMessage id="DESIGN_AND_PRICE" defaultMessage="Design & Price" />
    </Button>
  )
}

export default DesignAndPriceButton
